<template>
    <div class="address">
        <Head
            :headInfo='headInfo'
            @onClickLeft='onBack'
            @onClickRight='onSubmit'
        />
        <div class="itemList" v-if="addressList.length">
            <div class="item" v-for="item in addressList" :key="item.id">
                <div class="item-left" @click="onAddress(item)">
                    <div class="item1-left" v-if="typeNum">
                        <input class="doRadio" type="radio" name="sex" v-if="addressListId" :checked="item.id === addressListId">
                        <input class="doRadio" type="radio" name="sex" v-if="!addressListId" :checked="item.isDefault">
                        <label></label>
                    </div>
                    <div class="item1-center">
                        <div class="name">{{ item.name }}<span v-text="item.phone"></span></div>
                        <div class="content"><span v-show="item.isDefault">默认</span><span class="tolerate" v-text="item.province + ' '+ item.city + ' ' + item.area + ' '+ item.address"></span></div>
                    </div>
                </div>
                <div class="item-right">
                    <p class="borderLeft" @click="onEditAddress(item.id)">编辑</p>
                </div>
            </div>
        </div>
        <div class="msg" v-else>
            <img src="../../../assets/img/b2b/tips.png" alt="">
            暂无收货地址
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant'
import Head from '../../common/head'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
    name: 'addressList',
    components: {
        Head
    },
    props: {
        type: {
            type: Number,
            default: 0
        },
        addressListInfo: {
            type: Object,
            default: () => {
                return {
                    oldAddressId: '',
                    id: ''
                }
            }
        }
    },
    data () {
        return {
            headInfo: {
                title: '选择收货地址',
                rightText: '添加新地址'
            },
            typeNum: 0,
            userInfo: {},
            addressListId: '', // 选中的地址
            addressInfoData: null,
            memberCode: '',
            addressList: []
        }
    },
    computed: {
        ...mapState({
            addressInfo: state => state.b2b.addressList
        })
    },

    methods: {
        ...mapMutations({
            setAddressList: 'GET_ADDRESS_INFO'
        }),
        ...mapActions(['getAddressListData']),
        onBack () {
            if (this.typeNum === 1) {
                this.$emit('onShow')
            } else {
                this.$router.back()
            }
        },
        onAddress (item) {
            if (!this.typeNum) {
                return false
            }
            if (this.typeNum === 5) {
                this.setAddressList(item)
                this.$router.back()
            } else {
                this.$emit('getAddressBack', item)
            }
        },
        onSubmit () {
            if (this.addressList.length < 10) {
                this.$router.push({ path: '/b2b/address/addAddress' })
            } else {
                Toast('地址不能超过10个')
            }
        },
        onEditAddress (val) {
            this.$router.push({ path: '/b2b/address/editAddress', query: { addressId: val, activityShow: this.$route.query.activityShow, type: this.type } })
        },
        getAddressList () {
            this.getAddressListData({
                memberCode: this.userInfo.companyCode
            }).then((data) => {
                for (let i = 0; i < data.length; i++) {
                    data[i]['isCheck'] = false
                    data[i]['oldAddressId'] = data[i]['id'] // 配合开具发票id选中
                }
                this.addressList = data
            })
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.typeNum = parseInt(this.type || this.$route.query.type)
        if (this.typeNum === 1) {
            this.addressInfoData = this.addressListInfo
        } else {
            this.addressInfoData = this.addressInfo
        }
        // 优先获取oldAddressId，如果没有则获取id
        this.addressListId = this.addressInfoData.oldAddressId || this.addressInfoData.id
        if (!this.typeNum) {
            this.headInfo.title = '地址管理'
        }
        this.getAddressList()
    }
}
</script>
<style lang="scss" scoped>
.address {
    font-size: 28px;
    color: #000000;
    height: 100%;
    overflow: hidden;
    .itemList {
        padding: 0 32px;
        background: #ffffff;
        height: calc(100% - 80px);
        overflow: auto;
        .item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 60px;
            &:last-child {
                margin-bottom: 60px;
            }
            .item-left {
                display: flex;
                justify-content: flex-start;
                white-space: normal;
                word-break: break-all;
                .item1-left {
                    display: flex;
                    align-items: center;
                    margin-right: 5px;
                    input {
                        position: absolute;
                        margin: 0;
                    }
                }
                .item1-center {
                    .name {
                        font-size: 32px;
                        margin-bottom: 10px;
                        span {
                            font-size: 28px;
                            color: #999999;
                            margin-left: 28px;
                        }
                    }
                    .content {
                        line-height: 40px;
                        span {
                            &:first-child {
                                color: #ff7a45;
                                padding: 4px 10px;
                                line-height: 40px;
                                font-size: 24px;
                                text-align: center;
                                background: #fff1ec;
                                border-radius: 12px;
                                margin-right: 20px;
                            }
                        }
                    }
                }
            }
            .item-right {
                margin-left: 20px;
                flex: 0 0 76px;
                display: flex;
                justify-content: flex-end;
                text-align: right;
                p {
                    position: relative;
                    color: #999999;
                    height: 80px;
                    line-height: 80px;
                    padding-left: 18px;
                }
            }
        }
    }
    .msg {
        width: 182px;
        font-size: 26px;
        color: #c7c7cc;
        margin: 0 auto;
        padding-top: 160px;
        img {
            width: 176px;
            height: 176px;
            margin: 0 auto;
        }
    }
}
</style>